import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const RestoreScroll = () => {
	const { pathname } = useLocation();

	useEffect(() => {
		// console.log('SHOULD BE RESTORED!!!')
		// window.scrollTo(0, 0);
	}, [pathname]);

	// console.log('path', pathname);
	return null;
};

export default RestoreScroll;
